export enum EButtonType {
  Link = 'link',
  Text = 'text',
  Primary = 'primary',
  Default = 'default',
  Dashed = 'dashed',
}
